module.exports = __webpack_public_path__ + "static/media/backButton.dbdd0fb1.svg";